export const getJupasOrderRankLabel = (index) => {
  const rank = index + 1;
  if (rank <= 3) return `A${rank}`;
  if (rank <= 6) return `B${rank}`;
  if (rank <= 10) return `C${rank}`;
  if (rank <= 15) return `D${rank}`;
  if (rank <= 20) return `E${rank}`;
  return String(rank);
};

/** EDVise theme blue for calculator chrome (steps, sidebar pills — not band labels). */
export const EDVISE_THEME_BLUE = '#185FA5';

export const JUPAS_STEP_ICON_COLOR = EDVISE_THEME_BLUE;

/** Pastel band label colors (light backgrounds — use dark label text). */
export const JUPAS_BAND_COLORS = {
  A: '#FECCCB',
  B: '#FFDA8F',
  C: '#FEFF99',
  D: '#99FFCD',
  E: '#B3D7F9',
  other: '#E0E0E0',
};

export const getJupasOrderBandColor = (index) => {
  const rank = index + 1;
  if (rank <= 3) return JUPAS_BAND_COLORS.A;
  if (rank <= 6) return JUPAS_BAND_COLORS.B;
  if (rank <= 10) return JUPAS_BAND_COLORS.C;
  if (rank <= 15) return JUPAS_BAND_COLORS.D;
  if (rank <= 20) return JUPAS_BAND_COLORS.E;
  return JUPAS_BAND_COLORS.other;
};
